/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Notifications_Message_Body_MeanInputs */

const he_notifications_message_body_mean = /** @type {(inputs: Notifications_Message_Body_MeanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ממוצע ${i?.price}`)
};

const en_notifications_message_body_mean = /** @type {(inputs: Notifications_Message_Body_MeanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`avg ${i?.price}`)
};

/**
* | output |
* | --- |
* | "avg {price}" |
*
* @param {Notifications_Message_Body_MeanInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_mean = /** @type {((inputs: Notifications_Message_Body_MeanInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_MeanInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_mean(inputs)
	return en_notifications_message_body_mean(inputs)
});